import * as React from "react";
import {Component, Fragment} from "react";
import DispatchProps from "../../utils/DispatchProps";
import ApiService from "../ApiService";
import {CommandBarButton, PrimaryButton, TextField} from "office-ui-fabric-react";
import { DurableFunctionInstance } from "../../models/DurableFunctionInstance";
import MailroomDurableFunctionInstanceList from "./MailroomDurableFunctionInstanceList";
import WorkloadOutputViewer from "../WorkloadOutputViewer";


interface MailroomTimingAnalysisCardProps {
    apiService: ApiService;
}

interface MailroomTimingAnalysisCardState {
    
    tenantIdToGenerate?: string;
    
    instanceIdToView: string;
    instance?: DurableFunctionInstance;

    timingAnalysisResults?: any; 
}

export class MailroomTimingAnalysisCard extends Component<MailroomTimingAnalysisCardProps,MailroomTimingAnalysisCardState> {
    
    constructor(props: MailroomTimingAnalysisCardProps) {
        super(props);

        this.state = {
            tenantIdToGenerate: undefined,
            
            instanceIdToView: "",
            instance: undefined,
            
            timingAnalysisResults: undefined
        };
    }

    async componentDidMount(): Promise<void> {
    }

    async componentDidUpdate(prevProps: Readonly<MailroomTimingAnalysisCardProps & DispatchProps>, prevState: any): Promise<void>
    {
    }
    
    private onRefreshClick = async () => {
        const instance = await this.props.apiService.getMailroomFunctionInstance(this.state.instance?.durableFunctionInstanceId!);

        this.setState({ instanceIdToView: instance.durableFunctionInstanceId, instance });
    }

    private buildDurableFunctionBox() {

        if (this.state.instance == null) {
            return <div></div>
        }

        return <MailroomDurableFunctionInstanceList
            title={"Orchestration"}
            enableRowLinks={false}
            instances={[this.state.instance]}
            columns={MailroomDurableFunctionInstanceList.genericColumns}>
            <CommandBarButton text="Refresh" iconProps={{ iconName: "refresh" }} onClick={this.onRefreshClick} />
        </MailroomDurableFunctionInstanceList>

    }

    public render(): JSX.Element {
        return (
            <Fragment>
                {this.state.instance == undefined ? null : this.buildDurableFunctionBox()}
                <div className="card card">
                    <div className="card__header">
                        <span className={"card__title"}>Timing analysis</span>
                    </div>
                    <div className="card__content">
                        <div
                            className={"card__content flex-row flex--justify-content-center flex--align-items-flex-end"}>
                            <TextField
                                label="Tenant id"
                                value={this.state.tenantIdToGenerate}
                                onChange={(e: any) => {
                                    this.setState({
                                        tenantIdToGenerate: e.target.value
                                    })
                                }}
                                style={{width: '30rem'}}
                            />
                            <PrimaryButton text="Timing analysis for tenant (CDB-2024)" onClick={async () => {

                                if (this.state.tenantIdToGenerate === undefined) {
                                    return;
                                }
                                const timingAnalysisResults = await this.props.apiService.getMailroomTimingAnalysis(this.state.tenantIdToGenerate, "CDB-2024");
                                this.setState({
                                    timingAnalysisResults: timingAnalysisResults
                                });
                            }} style={{marginLeft: '1rem'}}/>
                        </div>
                        
                        <br/>
                        <div className="flex-row flex--justify-content-center">
                            <PrimaryButton text="Start all timing analysis orchestration" onClick={async () => {

                                const instance = await this.props.apiService.triggerMailroomGetAllTimingAnalysisOrchestration();
                                this.setState({
                                    instance: instance
                                });

                            }} style={{marginRight: '1rem'}}/>
                            <PrimaryButton text="View orchestration results" onClick={async () => {

                                const output = await this.props.apiService.getDurableFunctionInstanceOutput("mailroom", this.state.instanceIdToView);
                                this.setState({
                                    timingAnalysisResults: output
                                });

                            }} style={{marginLeft: '1rem'}}/>
                            <PrimaryButton text="Merge orchestration results with silver data" onClick={async () => {

                                const output = await this.props.apiService.devGetTimingAnalysis(this.state.instanceIdToView);
                                this.setState({
                                    timingAnalysisResults: output
                                });

                            }} style={{marginLeft: '1rem'}}/>
                        </div>
                        <div className="flex-row flex--justify-content-center">
                            <TextField
                                label="Instance ID To view"
                                value={this.state.instanceIdToView}
                                onChange={(e: any) => {
                                    this.setState({
                                        instanceIdToView: e.target.value
                                    })
                                }}
                                style={{width: '30rem'}}
                            />
                        </div>
                    </div>
                </div>

                {this.state.timingAnalysisResults ? <WorkloadOutputViewer title={"Timing Analysis JSON"} jsonObject={this.state.timingAnalysisResults}/> : null}
            </Fragment>
        );
    }
}